// Notes Management Permissions

export const NOTES_INDEX = 77;
export const NOTES_SHOW = NOTES_INDEX;
export const NOTES_CREATE = 78;
export const NOTES_EDIT = 79;
export const NOTES_DELETE = 80;
export const NOTES_RESTORE = 1384;
